
    var riot = require('riot')
    
riot.tag2('education_details', '<raw content="{opts.opts.education_details}"></raw> <ul class="nav nav-tabs"> <li each="{ref, i in opts.psedata.educations}" class="{active:parent.education_id == i}"><a href="./education_details/{i+1}" class="heading btn">{i+1}</a></li> <li><a onclick="{addEducation}" class="btn btn-success">Add Education</a></li> <li> <confirm onconfirm="{deleteEducation}"><a class="btn btn-danger">Delete Education</a></confirm> </li> </ul> <div class="tab-content"> <div class="tab-pane {active: education}"> <div class="col-xs-10 col-xs-offset-1"> <form class="form-horizontal"> <popover parent="{infoParent}"> <raw content="{parent.info}"></raw> </popover> <forminput label="Title of Award" value="{education.qual_award}" name="qual_award" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.education.qual_award)}"></forminput> <forminput label="Title of degree/diploma etc" value="{education.qual_title}" name="qual_title" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.education.qual_title)}"></forminput> <forminput label="Grade or Class" value="{education.qual_grade}" name="qual_grade" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.education.qual_grade)}"></forminput> <forminput label="Award Date*" value="{education.qual_date}" name="qual_date" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.education.qual_date)}" isrequired></forminput> <forminput label="Name of Establishment" value="{education.qual_orgname}" name="qual_orgname" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.education.qual_orgname)}"></forminput> <formselect label="Method of Verification" value="{education.qual_verification}" name="qual_verification" onupdate="{handleUpdate}" default="Please Select" options="{opts.selects.education_verifications}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.education.qual_verification)}" isrequired></formselect> <formselect label="Referee" value="{education.qual_referee}" name="qual_referee" onupdate="{handleUpdate}" default="Please Select" options="{referees}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.education.qual_referee)}" if="{education.qual_verification == \'Referee Attestation\'}"></formselect> <fileinput label="Upload Certificate" name="qual_files" files="{educationFiles}" onupdate="{handleUpload}" onremove="{handleRemove}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.education.qual_files)}" isrequired="{educationErrors.indexOf(\'qual_files\') &gt; -1}" if="{education.qual_verification != \'Referee Attestation\'}"></fileinput> </form> </div> </div> </div>', '', '', function(opts) {
this.files = [];

this.referees = [];

this.educations = [];

this.mounted = false;

this.on('mount', function() {
  this.mounted = true;
  if (opts.errors != null) {
    return setTimeout((function(_this) {
      return function() {
        return _this.checkErrors();
      };
    })(this));
  }
});

this.infobutton = "<span class=\"fa fa-info\" style=\"pointer-events:none\"></span>";

this.showInfo = (function(_this) {
  return function(info, e) {
    _this.info = info;
    _this.infoParent = e.target;
    _this.tags.popover.clicked(e);
    return _this.update();
  };
})(this);

this.on('update', function() {
  if (opts.files != null) {
    this.files = opts.files.filter(function(f) {
      return f.path.match(/^ed_/);
    });
  }
  if ((opts.errors != null) && this.mounted) {
    this.checkErrors();
  }
  if (opts.psedata != null) {
    this.referees = opts.psedata.referees.filter(function(r) {
      var ref;
      return ((ref = r.ref_name) != null ? ref.length : void 0) > 0;
    }).map(function(r) {
      return {
        label: r.ref_name,
        value: r.ref_name
      };
    });
    return this.load();
  }
});

this.checkErrors = (function(_this) {
  return function() {
    _this.educationErrors = opts.errors.filter(function(e) {
      return e.tab === 'educations';
    }).map(function(e) {
      return e.field;
    });
    _this.update();
    return _this.educationErrors.forEach(function(field) {
      return _this.tags[field].tags['formgroup'].trigger('validate');
    });
  };
})(this);

this.load = function() {
  var ref, regex;
  this.educations = opts.psedata.educations;
  this.education_id = opts.params.education_id != null ? opts.params.education_id - 1 : 0;
  if (((ref = this.educations) != null ? ref[this.education_id] : void 0) != null) {
    this.education = this.educations[this.education_id];
  }
  regex = new RegExp('ed_' + (this.education_id + 1) + '_');
  this.educationFiles = this.files.filter(function(f) {
    return f.path.match(regex);
  });
  return this.update();
};

this.addEducation = function() {
  this.educations.push({});
  opts.page.redirect('education_details/' + this.educations.length);
  return this.update();
};

this.deleteEducation = (function(_this) {
  return function() {
    _this.educations.splice(_this.education_id, 1);
    opts.page.redirect('education_details/' + _this.educations.length);
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(val) {
    _this.education[val.name] = val.value;
    return opts.onupdate('educations', _this.education_id, _this.education);
  };
})(this);

this.handleUpload = (function(_this) {
  return function(val) {
    var data, file;
    if ((val != null ? val[0] : void 0) != null) {
      file = val[0];
      data = new FormData();
      data.append('file', file);
      data.append('name', 'ed_' + (_this.education_id + 1) + "_" + file.name);
      return fetch('/duocms/api/pse/file', {
        method: 'POST',
        credentials: "include",
        headers: {
          'x-csrf-token': window.csrf
        },
        body: data
      }).then(function() {
        return opts.onupdate('files', 'add', {
          path: 'ed_' + (_this.education_id + 1) + "_" + file.name
        });
      });
    }
  };
})(this);

this.handleRemove = (function(_this) {
  return function(file) {
    return fetch('/duocms/api/pse/file?path=' + file.path, {
      method: 'DELETE',
      credentials: "include",
      headers: {
        'x-csrf-token': window.csrf
      }
    }).then(function() {
      return opts.onupdate('files', 'remove', file);
    });
  };
})(this);
});
    
  